export const PROFILE_NAME_CHANGED_EVENT = "iloris:profile-name-changed";

export interface ProfileNameChangedDetail {
    userId: string;
    displayName: string;
}

export function notifyProfileNameChanged(userId: string, displayName: string) {
    window.dispatchEvent(
        new CustomEvent<ProfileNameChangedDetail>(PROFILE_NAME_CHANGED_EVENT, {
            detail: { userId, displayName },
        }),
    );
}
